// Copyright (c) 2016 Deere & Company

import UserPrivacy, {getDefaultState as getUserPrivacyDefaultState} from './user-privacy';
import UserSettings, {getDefaultState as getUserSettingsDefaultState} from './user-settings';
import t from 'tcomb';

const User = t.struct({
    anonymousId: t.String,
    firstName: t.String,
    id: t.String,
    lastName: t.String,
    privacy: UserPrivacy,
    retrieveAccounts: t.String,
    settings: UserSettings
}, {
    name: 'User',
    strict: true
});

export const getDefaultState = () => new User({
    anonymousId: '',
    firstName: '',
    id: '',
    lastName: '',
    privacy: getUserPrivacyDefaultState(),
    retrieveAccounts: 'N',
    settings: getUserSettingsDefaultState()
});

User.prototype.getCkcValue = function getCkcValue() {

    const localeKey = this.settings.language.primaryLanguage.key;

    const selectedLanguage = this.settings.language.primaryLanguage.allowedPrimaryLanguages.find(language => language.key === localeKey);

    return selectedLanguage.ckcValue;

};

User.prototype.getDateFormatValue = function getDateFormatValue() {

    return this.settings.general.dateFormat.value;

};

User.prototype.getLocale = function getLocale() {

    return this.settings.language.primaryLanguage.key;

};

export default User;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/user.js